
export function cleanOnlineCategories (onlineCategories) {
  if (onlineCategories) {
    for (let i = onlineCategories.length - 1; i >= 0; i--) {
      const oc = onlineCategories[i]
      if (oc.categoryType &&
            ((oc.categoryType === 'MENU' && !oc.categoryIds.length) ||
                (oc.categoryType !== 'MENU' && !oc.offers.length))) {
        onlineCategories.splice(i, 1)
      }
    }
  }
}
